"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.string.replace.js");
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _typeValidation = _interopRequireDefault(require("./typeValidation"));
var _inputTextarea = require("@citrus/input-textarea");
var _PctyQuestion = require("./PctyQuestion.Common");
var PctyQuestionMultiLine = function PctyQuestionMultiLine(_ref) {
  var id = _ref.id,
    number = _ref.number,
    disabled = _ref.disabled,
    readOnly = _ref.readOnly,
    required = _ref.required,
    scenario = _ref.scenario,
    question = _ref.question,
    response = _ref.response,
    hint = _ref.hint,
    onResponse = _ref.onResponse,
    placeholder = _ref.placeholder;
  var htmlFriendlyText = readOnly && response && response.length > 0 ? response.replace(/\n/gi, '<br/>') : response;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, (0, _PctyQuestion.renderHint)(id, hint), (0, _PctyQuestion.renderScenario)(id, scenario), (0, _PctyQuestion.renderQuestion)(id, number, question, required, readOnly), readOnly ? /*#__PURE__*/_react.default.createElement("div", {
    className: "pcty-border-all",
    style: {
      padding: '10px'
    },
    dangerouslySetInnerHTML: {
      __html: htmlFriendlyText
    }
  }) : /*#__PURE__*/_react.default.createElement(_inputTextarea.Textarea, {
    id: id,
    disabled: disabled,
    readOnly: readOnly,
    onChange: function onChange(_ref2) {
      var id = _ref2.id,
        value = _ref2.value;
      return onResponse(id, value);
    },
    placeholder: placeholder,
    automationId: "question-".concat(number, "-MultiLine-Textarea"),
    value: response
  }));
};
PctyQuestionMultiLine.propTypes = {
  /** A hint that you want to give the person answering the question. */
  hint: _propTypes.default.string,
  /** The id for the component. */
  id: _propTypes.default.string.isRequired,
  /** Whether or not the question will be displayed as required. */
  required: _propTypes.default.bool,
  /** Whether or not the question will be disabled. */
  disabled: _propTypes.default.bool,
  /** Whether or not the question will be readOnly. */
  readOnly: _propTypes.default.bool,
  /** The placeholder text to display in the text field */
  placeholder: _propTypes.default.string,
  /** The question number. */
  number: _propTypes.default.number.isRequired,
  /** Callback function that receives response information each time someone interacts with the question. */
  onResponse: _propTypes.default.func.isRequired,
  /** The question text. */
  question: _propTypes.default.string.isRequired,
  /** An array of response objects that are output from the component. */
  response: _propTypes.default.string,
  /** Some text that sets up your question. */
  scenario: _propTypes.default.string,
  __TYPE: function __TYPE(props, propName, componentName) {
    return (0, _typeValidation.default)(props, propName, componentName, 'PctyQuestionMultiLine');
  }
};
PctyQuestionMultiLine.defaultProps = {
  scenario: null,
  placeholder: 'Enter text',
  disabled: false,
  readOnly: false,
  __TYPE: 'PctyQuestionMultiLine'
};
var _default = exports.default = PctyQuestionMultiLine;